import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Box,
  Typography,
  Button,
  Avatar,
  Paper,
  IconButton,
  LinearProgress,
  Chip,
  Slider,
  TextField,
  CircularProgress,
  Modal,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { styled, useMediaQuery, useTheme } from "@mui/system";
import { COLORS } from "../utils/COLORS";
import { useParams, useNavigate, Link } from "react-router-dom";
import UploadIcon from "@mui/icons-material/Upload";
import GlobalStateContext from "../context/globalStateContext";
import UserContext from "../context/userContext";
import SubModal from "../components/SubModal";
import AuthModal from "../components/AuthModal";
import AddCardModal from "../components/AddCardModal";
import ClaimFundsModal from "../components/ClaimFundsModal";
import SaviorRewardInfoModal from "../components/SaviorRewardInfoModal";
import ConfirmPledgeModal from "../components/ConfirmPledgeModal";
import Header from "../components/Header";
import FooterComponent from "../components/Footer";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { off, onValue, ref, get } from "firebase/database";
import { database, firestore, functions, firebase } from "../firebaseConfig";
import { httpsCallable } from "firebase/functions";
import { calculateCountdown, calculateDogTimeRemaining, formatDogAge, groupPledgesByAnimalId, formatCountdownTimer, sortDogsByUrgency } from "../utils/HELPER_FUNCTIONS";
import { toast } from "react-simple-toasts";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkIcon from "@mui/icons-material/Link";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import ScaleIcon from "@mui/icons-material/Scale";
import WcIcon from "@mui/icons-material/Wc";
import PetsIcon from "@mui/icons-material/Pets";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HeightIcon from "@mui/icons-material/Height";
import InfoIcon from "@mui/icons-material/Info";
import ShareIcon from "@mui/icons-material/Share";
import IosShareIcon from "@mui/icons-material/IosShare";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DownloadIcon from "@mui/icons-material/Download";
import * as amplitude from '@amplitude/analytics-browser';
import logoImage from "../assets/logo.png";

// const stripePromise = loadStripe("pk_test_51SXQsNEpOMZzOmc9pDIthSMtBZ0FrlKCm7sjCSIitmvZ5ocGAZAKiRqNzj7GPjtFIryTjjzBGuuM787TFLOwa9r900CaYV0J9T"); // TEST - process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY LIVE
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// PIXEL PERFECT STYLED COMPONENTS
const PageContainer = styled(Box)({
  width: "100vw",
  maxWidth: "100%",
  minHeight: "100vh",
  backgroundColor: "#000000", // EXACT: Pure black background
  color: "#FFFFFF",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#000000",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#1E293B",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#334155",
    },
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "#000000",
  },
});


const MainContainer = styled(Box)(({ theme }) => ({
  maxWidth: "800px",
  margin: "0 auto",
  padding: "20px 24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  [theme.breakpoints.down("md")]: {
    padding: "10px 16px",
    alignItems: "flex-start",
  },
}));

const TopSection = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "32px",
  marginBottom: "40px",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
    alignItems: "center",
  },
}));

const DogPhotoContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  flex: "0 0 400px",
  [theme.breakpoints.down("md")]: {
    flex: "none",
    width: "100%",
   
  },
}));

const DogPhotoCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: "12px",
  padding: "0px",
  textAlign: "center",
  border: "none",
  position: "relative",
  width: "400px",
  height: "450px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    // height: "350px",
  },
}));


const PhotoPlaceholder = styled(Typography)({
  color: "#94A3B8",
  fontSize: "16px",
  fontWeight: "500",
});

const DogInfoSection = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingTop: "24px",
  [theme.breakpoints.down("md")]: {
    paddingTop: "0px",
    marginTop: "0px",
  },
}));

const DogName = styled(Typography)(({ theme }) => ({
  fontSize: "48px",
  fontWeight: "700",
  color: "#FFFFFF",
  marginBottom: "4px",
  lineHeight: "1.1",
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
    textAlign: "center",
  },
}));

const AnimalId = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "400",
    textTransform: "uppercase",

  color: "#6B7280",
  marginBottom: "8px",
  
 
}));



const UrgencyHeroBanner = styled(Box)(({ theme }) => ({
  width: "400px",
  padding: "12px 16px",
  backgroundColor: "#991B1B",
  borderRadius: "8px",
  border: "none",
  textAlign: "center",
  marginBottom: "12px",
  boxSizing: "border-box",
  boxShadow: "0 4px 12px rgba(153, 27, 27, 0.4)",
  animation: "urgencyPulse 2s ease-in-out infinite",
  "@keyframes urgencyPulse": {
    "0%": {
      backgroundColor: "#991B1B",
      boxShadow: "0 4px 12px rgba(153, 27, 27, 0.4)",
    },
    "50%": {
      backgroundColor: "#B91C1C",
      boxShadow: "0 4px 20px rgba(185, 28, 28, 0.6)",
    },
    "100%": {
      backgroundColor: "#991B1B",
      boxShadow: "0 4px 12px rgba(153, 27, 27, 0.4)",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    backgroundColor: "#991B1B",
    border: "none",
    borderRadius: "8px",
    padding: "6px 12px",
    boxShadow: "0 4px 12px rgba(153, 27, 27, 0.4)",
  },
}));

const UrgencyTimer = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: "700",
  color: "#FFFFFF",
  fontFamily: "monospace",
  letterSpacing: "2px",
  lineHeight: "1",
  marginTop: "0px",
  [theme.breakpoints.down("md")]: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#FFFFFF",
    textShadow: "0 2px 8px rgba(0,0,0,0.4)",
    letterSpacing: "3px",
    lineHeight: "1",
    marginTop: "0px",
  },
}));

const UrgencyLabel = styled(Typography)(({ theme }) => ({
  fontSize: "11px",
  fontWeight: "600",
  color: "#FFFFFF",
  textTransform: "uppercase",
  letterSpacing: "1px",
  marginBottom: "0px",
  [theme.breakpoints.down("md")]: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: "600",
    letterSpacing: "1px",
    marginBottom: "4px",
    marginTop: "4px",
  },
}));

const EuthanasiaText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: "#9CA3AF",
  fontWeight: "400",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
    fontSize: "14px",
  },
}));

const ExpandedText = styled(Box)(({ theme }) => ({
  fontSize: "16px",
  color: "#9CA3AF",
  marginBottom: "8px",
  fontWeight: "400",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

const ExpandedLabel = styled(Typography)({
  fontSize: "inherit",
  color: "#6B7280",
  fontWeight: "500",
  textTransform: "uppercase",
});

const ExpandedValue = styled(Typography)({
  fontSize: "inherit",
  color: "#FFFFFF",
  fontWeight: "400",
  textAlign: "right",
  maxWidth: "60%",
});

const SectionHeader = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: "#10B981",
  fontWeight: "600",
  textTransform: "uppercase",
  letterSpacing: "1px",
  marginBottom: "12px",
  marginTop: "16px",
  [theme.breakpoints.down("md")]: {
    marginTop: "12px",
  },
}));

const ViewMoreButton = styled(Typography)({
  fontSize: "14px",
  color: "#10B981",
  cursor: "pointer",
  fontWeight: "500",
  display: "inline",
  marginLeft: "8px",
  "&:hover": {
    color: "#059669",
    textDecoration: "underline",
  },
});

const StatsContainer = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "8px",
  marginBottom: "16px",
});

const StatsContainerRow2 = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "8px",
});

const StatCard = styled(Paper)({
  backgroundColor: "#1F2937", // EXACT: Dark gray from design
  borderRadius: "8px",
  padding: "8px",
  textAlign: "center",
  flex: 1,
  border: "none",
  minHeight: "60px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

const StatIcon = styled(Box)({
  color: "#6B7280",
  marginBottom: "4px",
  display: "flex",
  justifyContent: "center",
});

const StatLabel = styled(Typography)({
  fontSize: "12px",
  color: "#9CA3AF",
  marginBottom: "2px",
  fontWeight: "400",
});

const StatValue = styled(Typography)({
  fontSize: "14px",
  fontWeight: "600",
  color: "#FFFFFF",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const HelpSaveSection = styled(Box)({
  textAlign: "center",
  marginBottom: "80px",
  maxWidth: "600px",
  margin: "0 auto 80px auto",
});

const HelpSaveTitle = styled(Typography)({
  fontSize: "32px",
  fontWeight: "600",
  color: "#FFFFFF",
  marginBottom: "8px",
});

const HelpSaveSubtitle = styled(Typography)({
  fontSize: "16px",
  color: "#9CA3AF",
  marginBottom: "40px",
  fontWeight: "400",
});

const DonationCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#0F172A",
  borderRadius: "14px",
  padding: "16px 16px 8px 16px",
  border: "1px solid #1E293B",
  width: "95%",
  margin: "20px 0 0 0",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
  },
  [theme.breakpoints.down("md")]: {
    margin: "20px auto 0 auto",
    maxWidth: "350px",
  },
}));

const ProgressSection = styled(Box)({
  marginBottom: "14px",
});

const ProgressHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "8px",
});

const ProgressLabel = styled(Typography)({
  fontSize: "12px",
  color: "#9CA3AF",
  fontWeight: "500",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
});

const ProgressAmount = styled(Typography)({
  fontSize: "22px",
  fontWeight: "700",
  color: "#FFFFFF",
  marginBottom: "8px",
});

const CustomProgressBar = styled(LinearProgress)({
  height: "4px",
  borderRadius: "2px",
  backgroundColor: "#374151",
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#10B981",
    borderRadius: "2px",
  },
  marginBottom: "6px",
});

const PercentageText = styled(Typography)({
  fontSize: "12px",
  color: "#9CA3AF",
  textAlign: "right",
  fontWeight: "500",
});

const ChooseAmountTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: "600",
  color: "#FFFFFF",
  marginBottom: "24px",
  textAlign: "left",
});

const AmountRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "12px",
  gap: "16px",
});

const SelectedAmountDisplay = styled(Typography)({
  fontSize: "28px",
  fontWeight: "700",
  color: "#FFFFFF",
  minWidth: "80px",
});

const StyledSlider = styled(Slider)({
  flex: 1,
  color: "#10B981",
  height: 4,
  "& .MuiSlider-track": {
    border: "none",
    backgroundColor: "#10B981",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#374151",
    opacity: 1,
  },
  "& .MuiSlider-thumb": {
    height: 16,
    width: 16,
    backgroundColor: "#10B981",
    border: "2px solid #FFFFFF",
    boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      backgroundColor: COLORS.primaryGreen,
      boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
    },
    "&:before": {
      display: "none",
    },
  },
});

const DonationAmounts = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: "6px",
  marginBottom: "14px",
});

const AmountButton = styled(Button)(({ selected }) => ({
  backgroundColor: selected ? "#10B981" : "#FFFFFF",
  color: selected ? "#FFFFFF" : "#000000",
  border: selected ? "1px solid #10B981" : "1px solid #E5E7EB",
  borderRadius: "8px",
  padding: "8px 6px",
  fontSize: "13px",
  fontWeight: "500",
  textTransform: "none",
  minWidth: "auto",
  transition: "all 0.15s ease",
  "&:hover": {
    backgroundColor: selected ? "#059669" : "#F3F4F6",
    transform: "translateY(-1px)",
  },
}));

const AmountTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    height: "100%",
    color: "#000000",
    fontSize: "13px",
    "& fieldset": {
      border: "none",
    },
    "&:hover": {
      backgroundColor: "#F3F4F6",
    },
    "&.Mui-focused": {
      backgroundColor: "#FFFFFF",
      border: "1px solid #10B981",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 6px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "500",
    color: "#000000",
    "&::placeholder": {
      color: "#6B7280",
      opacity: 1,
      fontWeight: "700",
    },
  },
});

const DonateButton = styled(Button)({
  width: "100%",
  backgroundColor: "#10B981",
  color: "#FFFFFF",
  borderRadius: "10px",
  padding: "12px",
  marginBottom: "14px",
  fontSize: "15px",
  fontWeight: "600",
  textTransform: "none",
  boxShadow: "0 2px 8px rgba(16, 185, 129, 0.25)",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#059669",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.35)",
  },
});

const StorySection = styled(Paper)({
  backgroundColor: "#1F2937", // EXACT: Dark gray from design
  borderRadius: "12px",
  padding: "32px",
  border: "none",
  marginBottom: "80px",
});

const StoryTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: "600",
  color: "#FFFFFF",
  marginBottom: "24px",
  textAlign: "center",
});

const StoryText = styled(Typography)({
  fontSize: "16px",
  lineHeight: "1.6",
  color: "#D1D5DB",
  marginBottom: "16px",
  fontWeight: "400",
});

const ShareSection = styled(Box)({
  textAlign: "center",
  marginBottom: "80px",
});

const ShareTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: "600",
  color: "#FFFFFF",
  marginBottom: "8px",
});

const ShareSubtitle = styled(Typography)({
  fontSize: "16px",
  color: "#9CA3AF",
  marginBottom: "32px",
  fontWeight: "400",
});

const SocialButtons = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "12px",
});

const SocialButton = styled(IconButton)({
  backgroundColor: "#374151",
  border: "none",
  borderRadius: "8px",
  padding: "12px",
  color: "#D1D5DB",
  "&:hover": {
    backgroundColor: "#4B5563",
    color: "#FFFFFF",
  },
});


const HorizontalScrollerContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#000000",
  padding: "24px 0",
  [theme.breakpoints.down("md")]: {
    padding: "8px 0",
    marginTop: "64px",
  },
}));

const ScrollerInner = styled(Box)({
  maxWidth: "800px",
  margin: "0 auto",
  padding: "0 24px",
});

const ShelterLabel = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "600",
  color: COLORS.gray, //  "#10B981",
  textTransform: "uppercase",
  letterSpacing: "1px",
  marginBottom: "16px",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
    marginBottom: "12px",
  },
}));

const DogScrollerWrapper = styled(Box)({
  display: "flex",
  overflowX: "auto",
  gap: "16px",
  paddingBottom: "8px",
  "&::-webkit-scrollbar": {
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#1F2937",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#374151",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: "#4B5563",
    },
  },
});

const DogScrollerCard = styled(Box)({
  minWidth: "160px",
  maxWidth: "160px",
  backgroundColor: "#1F2937",
  borderRadius: "8px",
  padding: "8px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#374151",
    transform: "translateY(-2px)",
  },
});

const DogCardThumbnail = styled(Avatar)({
  width: "100%",
  height: "140px",
  borderRadius: "6px",
  marginBottom: "8px",
  "& img": {
    objectFit: "cover",
  },
});

const DogCardMetaRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "4px",
  gap: "4px",
});

const DogCardName = styled(Typography)({
  fontSize: "13px",
  fontWeight: "600",
  color: "#FFFFFF",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  flex: 1,
});

const DogCardAge = styled(Typography)({
  fontSize: "13px",
  fontWeight: "600",
  color: "#FFFFFF",
  whiteSpace: "nowrap",
});

const DogCardTimeRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "4px",
  gap: "4px",
});

const DogCardTimeLabel = styled(Typography)({
  fontSize: "13px",
  fontWeight: "600",
  color: "#FFFFFF",
  whiteSpace: "nowrap",
});

const DogCardTime = styled(Typography)({
  fontSize: "13px",
  fontWeight: "600",
  color: "#FFFFFF",
  fontFamily: "monospace",
  whiteSpace: "nowrap",
});

const DogCardProgressBar = styled(LinearProgress)({
  height: "4px",
  borderRadius: "2px",
  backgroundColor: "#374151",
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#10B981",
    borderRadius: "2px",
  },
});

const NavigationArrow = styled(IconButton)(({ theme, position }) => ({
  position: "fixed",
  top: "50%",
  transform: "translateY(-50%)",
  [position]: "24px",
  width: "56px",
  height: "56px",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  color: "#FFFFFF",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(8px)",
  zIndex: 1000,
  opacity: 0.7,
  transition: "all 0.3s ease",
  "&:hover": {
    opacity: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    transform: "translateY(-50%) scale(1.1)",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
  },
  "&:disabled": {
    opacity: 0.3,
    cursor: "not-allowed",
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));


const ClaimSuccessMessage = styled(Typography)({
  fontSize: "14px",
  color: "#10B981",
  fontWeight: "500",
  textAlign: "center",
  marginTop: "8px",
  padding: "8px 12px",
  backgroundColor: "rgba(16, 185, 129, 0.1)",
  borderRadius: "6px",
  border: "1px solid rgba(16, 185, 129, 0.2)",
});

const MediaNavigationDots = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  marginTop: "12px",
});

const MediaDot = styled(Button)(({ active }) => ({
  minWidth: "8px",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  padding: "0",
  backgroundColor: active ? "#10B981" : "#374151",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: active ? "#059669" : "#4B5563",
    transform: "scale(1.2)",
  },
}));

const DownloadButton = styled(IconButton)({
  position: "absolute",
  bottom: "8px",
  right: "8px",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  color: "#FFFFFF",
  padding: "8px",
  backdropFilter: "blur(4px)",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(16, 185, 129, 0.8)",
    transform: "scale(1.05)",
  },
});

const DogProfilePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [dogProfile, setDogProfile] = useState(null);
  const [totalPledged, setTotalPledged] = useState(0);
  const [totalSubscriptions, setTotalSubscriptions] = useState(0);
  const [selectedAmount, setSelectedAmount] = useState(30);
  const [customAmount, setCustomAmount] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [isProcessingPledge, setIsProcessingPledge] = useState(false);
  const [allDogs, setAllDogs] = useState([]);
  const [currentDogIndex, setCurrentDogIndex] = useState(-1);
  const [nextDog, setNextDog] = useState(null);
  const [prevDog, setPrevDog] = useState(null);
  const [hasPendingClaim, setHasPendingClaim] = useState(false);
  const [isRescued, setIsRescued] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [rescueDate, setRescueDate] = useState(null);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState("");
  const [showSaviorRewardInfo, setShowSaviorRewardInfo] = useState(false);
  const [dogsForScroller, setDogsForScroller] = useState([]);
  const [saviorUser, setSaviorUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const donationAmounts = [10, 30, 50, 100];
  const fundingGoal = 2500;
  const fundingPercentage = Math.min((totalPledged / fundingGoal) * 100, 100);

  const getAllMedia = () => {
    if (!dogProfile) return [];
    const videos = dogProfile.videos || [];
    const images = dogProfile.images || [];
    return [
      ...videos.map(url => ({ type: 'video', url })),
      ...images.map(url => ({ type: 'image', url }))
    ];
  };

  const allMedia = getAllMedia();
  const currentMedia = allMedia[currentMediaIndex];

  const handleDownloadImage = async () => {
    console.log("🔵 Download button clicked");
    setDownloadLoading(true);

    try {
      const imageUrl = currentMedia?.type === 'image' ? currentMedia.url : dogProfile?.images?.[0];

      console.log("🔵 Selected image URL:", imageUrl);
      if (!imageUrl) {
        console.log("❌ No image URL found");
        toast("No image available to download");
        setDownloadLoading(false);
        return;
      }

      // Call Firebase Function to generate shareable image
      const functionUrl = `https://us-central1-pawsai-ecd07.cloudfunctions.net/generateShareableImage?imageUrl=${encodeURIComponent(imageUrl)}&dogSlug=${dogProfile.slug}&dogName=${encodeURIComponent(dogProfile.name)}`;

      console.log("🔵 Calling Firebase Function...");

      // Download the generated image
      const link = document.createElement('a');
      link.href = functionUrl;
      link.download = `${dogProfile.name}-pledgefast.png`;
      link.click();

      console.log("✅ Download initiated");
      toast("Image downloaded!");
      setDownloadLoading(false);

    } catch (error) {
      console.error("❌ Download error:", error);
      toast("Failed to download image: " + error.message);
      setDownloadLoading(false);
    }
  };

  // Auto-cycle images (not videos)
  useEffect(() => {
    if (allMedia.length <= 1) return; // Don't cycle if only one item
    if (currentMedia?.type === 'video') return; // Don't cycle on videos

    const interval = setInterval(() => {
      setCurrentMediaIndex((prev) =>
        prev === allMedia.length - 1 ? 0 : prev + 1
      );
    }, 4000); // 4 seconds per image

    return () => clearInterval(interval);
  }, [allMedia.length, currentMedia?.type]);

  useEffect(() => {
    const fetchAllDogs = async () => {
      setIsLoading(true);
      const startTime = Date.now();

      try {
        // First, get the current dog to determine its shelterId
        const currentDogSnapshot = await firestore
          .collection("web-available-dogs")
          .where("slug", "==", slug)
          .get();

        if (currentDogSnapshot.empty) {
          setDogProfile(null);
          return;
        }

        const currentDogDoc = currentDogSnapshot.docs[0];
        const currentDog = {
          id: currentDogDoc.id,
          ...currentDogDoc.data(),
        };

        // Fetch shelter data for current dog
        if (currentDog.shelterId) {
          try {
            const shelterDoc = await firestore
              .collection("availableShelters")
              .doc(currentDog.shelterId)
              .get();
            if (shelterDoc.exists) {
              currentDog.shelter = {
                id: shelterDoc.id,
                ...shelterDoc.data(),
              };
            }
          } catch (error) {
            console.error("Error fetching shelter data:", error);
          }
        }

        setDogProfile(currentDog);

        // Fetch dogs from the same shelter
        const shelterDogsSnapshot = await firestore
          .collection("web-available-dogs")
          .where("shelterId", "==", currentDog.shelterId)
          .get();

        let dogs = shelterDogsSnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter(dog => dog.euthanasiaStatus !== 'expired');


        // Calculate time remaining for each dog using helper function
        dogs = dogs.map(dog => {
          const timeRemaining = calculateDogTimeRemaining(dog, currentDog.shelter?.closingTime);
          return {
            ...dog,
            ...timeRemaining
          };
        });

        // Sort by time remaining (lowest to highest) with daysAtShelter tiebreaker
        dogs = sortDogsByUrgency(dogs, "most");

        // Filter out rescued dogs and current dog for horizontal scroller
        const dogsForScroller = dogs.filter(dog =>
          dog.euthanasiaStatus !== "rescued" && dog.slug !== slug
        );

        setDogsForScroller(dogsForScroller);

        // Fetch all pledges for this shelter to populate progress bars
        if (currentDog.shelterId && dogsForScroller.length > 0) {
          const shelterPledgesSnapshot = await firestore
            .collection("pledges")
            .where("shelterId", "==", currentDog.shelterId)
            .get();

          const shelterPledges = shelterPledgesSnapshot.docs.map(doc => doc.data());
          const pledgeMap = groupPledgesByAnimalId(shelterPledges);

          // Enrich dogs with pledge amounts
          const enrichedDogs = dogsForScroller.map(dog => ({
            ...dog,
            pledgedAmount: pledgeMap[dog.animalId] || 0
          }));

          setDogsForScroller(enrichedDogs);
        }

        // // If less than 20 dogs, fetch additional dogs from other shelters
        // if (dogs.length < 20) {
        //   const additionalDogsSnapshot = await firestore
        //     .collection("web-available-dogs")
        //     .get();

        //   const allDogsFromDb = additionalDogsSnapshot.docs
        //     .map((doc) => ({
        //       id: doc.id,
        //       ...doc.data(),
        //     }))
        //     .filter(dog => dog.euthanasiaStatus !== 'expired');

        //   // Filter out dogs already in the shelter dogs array
        //   const shelterDogIds = new Set(dogs.map(d => d.id));
        //   const otherDogs = allDogsFromDb.filter(d => !shelterDogIds.has(d.id));

        //   // Append other dogs to reach a good number
        //   dogs = [...dogs, ...otherDogs];
        //   console.log(`Appended dogs from other shelters. Total: ${dogs.length}`);
        // }

        setAllDogs(dogs);

        const currentIndex = dogs.findIndex((dog) => dog.slug === slug);
        setCurrentDogIndex(currentIndex);

        // Prefetch adjacent dogs
        const next = dogs[currentIndex + 1] || null;
        const prev = dogs[currentIndex - 1] || null;
        setNextDog(next);
        setPrevDog(prev);
      } catch (error) {
        console.error("Error fetching dogs:", error);
        setDogProfile(null);
      } finally {
        // Ensure minimum 3 second loading time for smooth UX
        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(0, 3000 - elapsedTime);

        setTimeout(() => {
          setIsLoading(false);
        }, remainingTime);
      }
    };

    fetchAllDogs();
  }, [slug]);

  // Fetch savior user data
  useEffect(() => {
    const fetchSaviorUser = async () => {
      if (!dogProfile?.createdBy) {
        setSaviorUser(null);
        return;
      }

      try {
        const userDoc = await firestore
          .collection("users")
          .doc(dogProfile.createdBy)
          .get();

        if (userDoc.exists) {
          // Fetch count of dogs listed by this user
          const dogsSnapshot = await firestore
            .collection("web-available-dogs")
            .where("createdBy", "==", dogProfile.createdBy)
            .get();

          setSaviorUser({
            uid: userDoc.id,
            ...userDoc.data(),
            dogsListedCount: dogsSnapshot.size,
          });
        } else {
          setSaviorUser(null);
        }
      } catch (error) {
        console.error("Error fetching savior user:", error);
        setSaviorUser(null);
      }
    };

    fetchSaviorUser();
  }, [dogProfile?.createdBy]);

  useEffect(() => {
    if (!dogProfile?.animalId) return;

    // Fetch pledges from flat Firestore pledges collection filtered by animalId
    const pledgesRef = firestore.collection(`pledges`).where("animalId", "==", dogProfile.animalId);
    const pledgesUnsubscribe = pledgesRef.onSnapshot(
      (snapshot) => {
        try {
          if (!snapshot.empty) {
            // Get pledges for this dog
            const dogPledges = snapshot.docs
              .filter((doc) => doc.exists)
              .map((doc) => ({ id: doc.id, ...doc.data() }));
            const total = dogPledges.reduce(
              (sum, pledge) => sum + (pledge.displayAmount || 0),
              0
            );
            setTotalPledged(total);

            // Check for rescue date from processed pledges
            const processedPledge = dogPledges.find(pledge => pledge.status === "processed" && pledge.rescueDate);
            if (processedPledge && processedPledge.rescueDate) {
              setRescueDate(processedPledge.rescueDate);
            }
          } else {
            setTotalPledged(0);
          }
        } catch (error) {
          console.error("Error processing pledges:", error);
          setTotalPledged(0);
        }
      },
      (error) => {
        console.error("Error listening to pledges:", error);
        setTotalPledged(0);
      }
    );

    // Fetch subscriptions from Firestore subscriptions collection filtered by slug
    const subscriptionsRef = firestore
      .collection("subscriptions")
      .where("dogSlug", "==", slug);
    const subscriptionsUnsubscribe = subscriptionsRef.onSnapshot(
      (snapshot) => {
        try {
          if (!snapshot.empty) {
            // Get subscriptions for this dog (already filtered by the where query)
            const dogSubscriptions = snapshot.docs
              .filter((doc) => doc.exists)
              .map((doc) => ({ id: doc.id, ...doc.data() }));
            const total = dogSubscriptions.reduce(
              (sum, subscription) => sum + (subscription.amount || 0),
              0
            );
            setTotalSubscriptions(total);
          } else {
            setTotalSubscriptions(0);
          }
        } catch (error) {
          console.error("Error processing subscriptions:", error);
          setTotalSubscriptions(0);
        }
      },
      (error) => {
        console.error("Error listening to subscriptions:", error);
        setTotalSubscriptions(0);
      }
    );

    return () => {
      pledgesUnsubscribe();
      subscriptionsUnsubscribe();
    };
  }, [dogProfile]);

  // Check for existing claims for this dog
  useEffect(() => {
    if (!dogProfile) return;

    const unsubscribe = firestore
      .collection("claims")
      .where("slug", "==", dogProfile.slug)
      .onSnapshot((querySnapshot) => {
        let pending = false;
        let rescued = false;
        let rescueDateFound = null;

        querySnapshot.forEach(doc => {
          const claim = doc.data();
          if (claim.claimStatus === "pending") pending = true;
          if (claim.claimStatus === "accepted") {
            rescued = true;
            rescueDateFound = claim.rescueDate || null;
          }
        });

        setHasPendingClaim(pending);
        setIsRescued(rescued);
        if (rescueDateFound) setRescueDate(rescueDateFound);
      });

    return () => unsubscribe();
  }, [dogProfile]);

  // Check if dog has been rescued
  useEffect(() => {
    if (!dogProfile) return;

    // Check dog's status in real-time
    const unsubscribe = firestore
      .collection("web-available-dogs")
      .where("slug", "==", dogProfile.slug)
      .onSnapshot((querySnapshot) => {
        if (!querySnapshot.empty) {
          const dogData = querySnapshot.docs[0].data();

          // Check if expired
          const expired = dogData.euthanasiaStatus === "expired";
          setIsExpired(expired);

          // Check if rescued
          const rescued =
            dogData.euthanasiaStatus === "rescued" ||
            dogData.claimStatus === "accepted";
          setIsRescued(rescued);

          // Set rescue date if available
          if (rescued && dogData.rescueDate) {
            setRescueDate(dogData.rescueDate);
          }
        }
      });

    return () => unsubscribe();
  }, [dogProfile]);

  // Live countdown timer
  useEffect(() => {
    if (!dogProfile?.euthanasiaDate) return;

    const updateCountdown = () => {
      const now = new Date();
      const today = now.toISOString().split('T')[0];
      const isToday = dogProfile.euthanasiaDate === today;

      // If today, use shelter closing time; otherwise end of day
      let deadline = "T23:59:59";
      if (isToday && dogProfile.shelter?.closingTime) {
        // closingTime is stored as 1900 for 7pm, convert to "19:00:00"
        const closeTime = dogProfile.shelter.closingTime.toString().padStart(4, "0");
        const hours = closeTime.slice(0, 2);
        const minutes = closeTime.slice(2, 4);
        deadline = `T${hours}:${minutes}:00`;
      }

      const euthanasiaDate = new Date(dogProfile.euthanasiaDate + deadline);
      const difference = euthanasiaDate.getTime() - now.getTime();

      setTimeRemaining(formatCountdownTimer(difference));
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [dogProfile?.euthanasiaDate, dogProfile?.shelter?.closingTime]);

  const handleOneClickPledge = async () => {
    // Prevent pledging if dog is already rescued
    if (isRescued) {
      toast("This dog has already been rescued! 🎉");
      return;
    }

    setIsProcessingPledge(true);

    try {
      const createCustomerForDelayedCharge = httpsCallable(
        functions,
        "createCustomerForDelayedCharge"
      );

      const tipAmount = 0 // keepPledgeFastFree ? calcAmount(15) : 0;
      const totalAmount = selectedAmount + tipAmount;

      const result = await createCustomerForDelayedCharge({
        email: user.email,
        amount: totalAmount * 100, // Convert to cents
        paymentMethodId: user.stripePaymentMethodId,
        dogSlug: dogProfile?.slug,
        orderDetails: {
          dogName: dogProfile?.name,
          pledgeAmount: selectedAmount,
          tipAmount: tipAmount,
          totalAmount: totalAmount,
        },
      });

      const { success, orderId, orderData } = result.data;

      if (success) {
        // Save to flat Firestore pledges collection
        await firestore
          .collection(`pledges`)
          .doc(orderId)
          .set({
            ...orderData,
            userId: user.uid,
            userEmail: user.email,
            userName: user.username,
            displayAmount: selectedAmount,
            tipAmount: tipAmount,
            totalAmount: totalAmount,
            createdAt: new Date().toISOString(),
            status: "requires_capture",
            slug: dogProfile?.slug,
            shelterId: dogProfile?.shelterId,
            name: dogProfile?.name,
            breed: dogProfile?.breed,
            age: dogProfile?.age,
            animalId: dogProfile?.animalId,
          });

        toast("Pledge successful!");

        // Track pledge event with Amplitude
        amplitude.track('pledge', {
          dogName: dogProfile?.name,
          dogSlug: dogProfile?.slug,
          pledgeAmount: selectedAmount,
          tipAmount: tipAmount,
          totalAmount: totalAmount,
          userId: user.uid,
          userEmail: user.email
        });

        // Open SubModal for subscription upsell after successful pledge
        setGlobalState({
          ...globalState,
          showSubModal: true,
          selectedDog: dogProfile,
        });
      } else {
        throw new Error("Failed to create pledge");
      }
    } catch (err) {
      toast("Pledge failed: " + err.message);
      console.error("Pledge error:", err);
    } finally {
      setIsProcessingPledge(false);
    }
  };

  const handleDonateClick = () => {
    if (!user) {
      setGlobalState({ ...globalState, showAuthModal: true });
    } else if (!user?.stripeCustomerId || !user?.stripePaymentMethodId) {
      setGlobalState({
        ...globalState,
        showAddCardModal: true,
        selectedDog: dogProfile,
      });
    } else {
      // Show ConfirmPledgeModal instead of direct pledge
      setGlobalState({
        ...globalState,
        showConfirmPledgeModal: true,
        selectedDog: dogProfile,
      });
    }
  };

  const navigateToDog = (targetDog) => {
    if (!targetDog) return;
    navigate(`/${targetDog.slug}`, { replace: true });
  };

  const handlePrevDog = () => {
    if (prevDog) {
      navigateToDog(prevDog);
    }
  };

  const handleNextDog = () => {
    if (nextDog) {
      navigateToDog(nextDog);
    }
  };

  const handleNextMedia = () => {
    if (currentMediaIndex < allMedia.length - 1) {
      setCurrentMediaIndex(currentMediaIndex + 1);
    }
  };

  const handlePrevMedia = () => {
    if (currentMediaIndex > 0) {
      setCurrentMediaIndex(currentMediaIndex - 1);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        handlePrevDog();
      } else if (e.key === "ArrowRight") {
        handleNextDog();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [prevDog, nextDog]);

  if (isLoading) {
    return (
      <PageContainer>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            gap: "16px",
          }}
        >
          <motion.img
            src={logoImage}
            alt="PledgeFast"
            style={{ width: "120px", opacity: 0.7, transformOrigin: "bottom center" }}
            animate={{ rotate: [0, 15, -15, 15, -15, 0] }}
            transition={{
              duration: 1.2,
              ease: "easeInOut",
            }}
          />
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 0.7, y: 0 }}
              transition={{ delay: 1.3, duration: 0.5 }}
            >
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#FFFFFF",
                }}
              >
                PledgeFast
              </Typography>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: 0.5, y: 0 }}
              transition={{ delay: 1.8, duration: 0.5 }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#FFFFFF",
                }}
              >
                We Save Dogs
              </Typography>
            </motion.div>
          </Box>
        </Box>
      </PageContainer>
    );
  }

  if (!dogProfile) {
    return (
      <PageContainer>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            gap: "16px",
          }}
        >
          <Typography>Sorry this dog didn't make it</Typography>
          <Button
            onClick={() => navigate("/")}
            sx={{
              backgroundColor: "#10B981",
              color: "#FFFFFF",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "14px",
              fontWeight: "500",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#059669",
              },
            }}
          >
            Go back home
          </Button>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      {/* Header */}
      <Header />

      <MainContainer>
        {/* Top Section - PIXEL PERFECT */}
        <TopSection>
          <DogPhotoContainer>
            {/* Urgency Banner - Above image */}
            {!isRescued && !isExpired && dogProfile && (
              <UrgencyHeroBanner>
                <UrgencyLabel>
                  {dogProfile.euthanasiaDate === new Date().toISOString().split('T')[0]
                    ? "WILL BE KILLED TODAY"
                    : "WILL BE KILLED IN"}
                </UrgencyLabel>
                <UrgencyTimer>{timeRemaining}</UrgencyTimer>
              </UrgencyHeroBanner>
            )}

            {isRescued && dogProfile && (
              <UrgencyHeroBanner style={{
                backgroundColor: COLORS.primaryGreen,
                animation: "none",
                boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
              }}>
                <UrgencyLabel style={{ color: "#FFFFFF" }}>
                  🎉 RESCUED 🎉
                </UrgencyLabel>
                {rescueDate && (
                  <UrgencyTimer style={{ color: "#FFFFFF" }}>
                    {new Date(rescueDate.toDate ? rescueDate.toDate() : rescueDate).toLocaleDateString()}
                  </UrgencyTimer>
                )}
              </UrgencyHeroBanner>
            )}

            {isExpired && dogProfile && (
              <UrgencyHeroBanner>
                <UrgencyTimer>UNAVAILABLE</UrgencyTimer>
              </UrgencyHeroBanner>
            )}

            <DogPhotoCard
              elevation={0}
            >
              {currentMedia ? (
                currentMedia.type === 'video' ? (
                  <video
                    src={currentMedia.url}
                    autoPlay
                    loop
                    muted
                    playsInline
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                      objectFit: isMobile ? "cover" : "contain",
                    }}
                  />
                ) : (
                  <Avatar
                    src={currentMedia.url}
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                      "& img": {
                        objectFit: isMobile ? "cover" : "contain",
                        borderRadius: "12px",
                      },
                    }}
                  />
                )
              ) : (
                <PhotoPlaceholder>No Media Available</PhotoPlaceholder>
              )}

              {/* Download Button */}
              {(currentMedia?.type === 'image' || dogProfile?.images?.length > 0) && (
                <Tooltip title="Download shareable image" placement="left">
                  <DownloadButton onClick={handleDownloadImage} disabled={downloadLoading}>
                    {downloadLoading ? (
                      <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
                    ) : (
                      <DownloadIcon sx={{ fontSize: "20px" }} />
                    )}
                  </DownloadButton>
                </Tooltip>
              )}
            </DogPhotoCard>

            {/* Media Navigation Dots */}
            {allMedia.length > 1 && (
              <MediaNavigationDots>
                {allMedia.map((_, index) => (
                  <MediaDot
                    key={index}
                    active={index === currentMediaIndex}
                    onClick={() => setCurrentMediaIndex(index)}
                  />
                ))}
              </MediaNavigationDots>
            )}

          </DogPhotoContainer>

          <DogInfoSection>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "4px",
                [theme.breakpoints.down("md")]: {
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
                <DogName sx={{ margin: 0 }}>{dogProfile.name}</DogName>
                {isMobile && (
                  <Typography sx={{ fontSize: "14px", color: "#9CA3AF", fontWeight: "400" }}>
                    ({dogProfile.gender ? dogProfile.gender.charAt(0).toUpperCase() : "?"})
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <Typography sx={{ fontSize: "14px", color: "#9CA3AF", fontWeight: "400", textTransform: "uppercase", textAlign: "right" }}>
                  {dogProfile.age ? `${dogProfile.age} OLD` : "UNKNOWN AGE"}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#9CA3AF", fontWeight: "400", textTransform: "uppercase", textAlign: "right" }}>
                  {dogProfile.breed || "UNKNOWN BREED"}
                </Typography>
              </Box>
              {/* <IconButton 
                onClick={() => {
                  if (navigator.share) {
                    navigator.share({
                      title: `Help save ${dogProfile.name}`,
                      text: `${dogProfile.name} needs our help! They're scheduled for euthanasia and need pledges to find a rescue.`,
                      url: window.location.href
                    });
                  } else {
                    navigator.clipboard.writeText(window.location.href);
                    toast("Link copied to clipboard!");
                  }
                }}
                sx={{ 
                  color: "#9CA3AF", 
                  padding: "8px",
                  "&:hover": { 
                    color: "#FFFFFF",
                    backgroundColor: "#1F2937" 
                  } 
                }}
              >
                <ShareIcon sx={{ fontSize: "20px" }} />
              </IconButton> */}
            </Box>
            <Box
              sx={{
                marginBottom: '12px',
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                cursor: "pointer"
              }}
              onClick={() => setShowMore(!showMore)}
            >
              <AnimalId sx={{ marginBottom: 0, color: "#9CA3AF", textAlign: "left" }}>
                {dogProfile.contactName || dogProfile.shelter?.name || "SAN ANTONIO ACS"}
              </AnimalId>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                {showMore ? (
                  <KeyboardArrowUpIcon sx={{ fontSize: "18px", color: "#10B981" }} />
                ) : (
                  <KeyboardArrowDownIcon sx={{ fontSize: "18px", color: "#10B981" }} />
                )}
              </Box>
            </Box>

            <AnimatePresence>
              {showMore && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{
                    duration: 0.4,
                    ease: [0.25, 0.46, 0.45, 0.94],
                    opacity: { duration: 0.3 },
                  }}
                  style={{ overflow: "hidden" }}
                >
                  {/* DETAILS */}
                  <SectionHeader sx={{ marginTop: "8px" }}>Details</SectionHeader>

                  <ExpandedText>
                    <ExpandedLabel>Description</ExpandedLabel>
                    <ExpandedValue>{!dogProfile.description ? "N/A" : ""}</ExpandedValue>
                  </ExpandedText>

                  {dogProfile.description && (
                    <Typography sx={{
                      fontSize: "14px",
                      color: "#FFFFFF",
                      marginBottom: "8px",
                      whiteSpace: "pre-wrap",
                      lineHeight: 1.5,
                      textAlign: "left",
                    }}>
                      {dogProfile.description}
                    </Typography>
                  )}

                  <ExpandedText>
                    <ExpandedLabel>Evaluation</ExpandedLabel>
                    <ExpandedValue>{!dogProfile.evaluationNotes && !dogProfile.evaluation ? "N/A" : ""}</ExpandedValue>
                  </ExpandedText>

                  {(dogProfile.evaluationNotes || dogProfile.evaluation) && (
                    <Typography sx={{
                      fontSize: "14px",
                      color: "#FFFFFF",
                      marginBottom: "8px",
                      whiteSpace: "normal",
                      lineHeight: 1.5,
                      textAlign: "left",
                    }}>
                      {dogProfile.evaluationNotes || dogProfile.evaluation}
                    </Typography>
                  )}

                  {dogProfile.gender && (
                    <ExpandedText>
                      <ExpandedLabel>Gender</ExpandedLabel>
                      <ExpandedValue>{dogProfile.gender.charAt(0).toUpperCase() + dogProfile.gender.slice(1).toLowerCase()}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.weight && (
                    <ExpandedText>
                      <ExpandedLabel>Weight</ExpandedLabel>
                      <ExpandedValue>{dogProfile.weight} lbs</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.size && (
                    <ExpandedText>
                      <ExpandedLabel>Size</ExpandedLabel>
                      <ExpandedValue>{dogProfile.size}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.color && (
                    <ExpandedText>
                      <ExpandedLabel>Color</ExpandedLabel>
                      <ExpandedValue>{dogProfile.color}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {/* RESCUE INFO - Priority for rescue orgs */}
                  <SectionHeader>Rescue Info</SectionHeader>

                  <ExpandedText>
                    <ExpandedLabel>Animal ID</ExpandedLabel>
                    <ExpandedValue>#{dogProfile.animalId || dogProfile.id || "A001"}</ExpandedValue>
                  </ExpandedText>

                  {dogProfile.shelter?.name && (
                    <ExpandedText>
                      <ExpandedLabel>Shelter</ExpandedLabel>
                      <ExpandedValue>{dogProfile.shelter.name}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.daysAtShelter && (
                    <ExpandedText>
                      <ExpandedLabel>Days at Shelter</ExpandedLabel>
                      <ExpandedValue>{dogProfile.daysAtShelter}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.reasonForRisk && (
                    <ExpandedText>
                      <ExpandedLabel>Reason for Death</ExpandedLabel>
                      <ExpandedValue>{dogProfile.reasonForRisk}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.shelter?.location && (
                    <ExpandedText>
                      <ExpandedLabel>Address</ExpandedLabel>
                      <ExpandedValue
                        component="a"
                        href={`https://maps.google.com/?q=${encodeURIComponent(dogProfile.shelter.location)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: "#10B981", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                      >
                        {dogProfile.shelter.location}
                      </ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.contactPhone && (
                    <ExpandedText>
                      <ExpandedLabel>Contact Phone</ExpandedLabel>
                      <ExpandedValue
                        component="a"
                        href={`tel:${dogProfile.contactPhone}`}
                        sx={{ color: "#10B981", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                      >
                        {dogProfile.contactPhone}
                      </ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.kennel && (
                    <ExpandedText>
                      <ExpandedLabel>Kennel</ExpandedLabel>
                      <ExpandedValue>{dogProfile.kennel}</ExpandedValue>
                    </ExpandedText>
                  )}

                  {dogProfile.intakeDate && (
                    <ExpandedText>
                      <ExpandedLabel>Intake Date</ExpandedLabel>
                      <ExpandedValue>
                        {new Date(dogProfile.intakeDate).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </ExpandedValue>
                    </ExpandedText>
                  )}

                  {/* MEDICAL */}
                  <SectionHeader>Medical</SectionHeader>

                  {dogProfile.healthIssues && dogProfile.healthIssues.length > 0 && (
                    <ExpandedText>
                      <ExpandedLabel>Health Issues</ExpandedLabel>
                      <ExpandedValue>{dogProfile.healthIssues.join(", ")}</ExpandedValue>
                    </ExpandedText>
                  )}

                  <ExpandedText>
                    <ExpandedLabel>Spayed/Neutered</ExpandedLabel>
                    <ExpandedValue>
                      {dogProfile.spayedNeutered === true ||
                      dogProfile.spayedNeutered === "true" ||
                      dogProfile.spayedNeutered === "Yes"
                        ? "Yes"
                        : "No"}
                    </ExpandedValue>
                  </ExpandedText>

                  <ExpandedText>
                    <ExpandedLabel>Vaccinated</ExpandedLabel>
                    <ExpandedValue>
                      {dogProfile.vaccinated === true ||
                      dogProfile.vaccinated === "true" ||
                      dogProfile.vaccinated === "Yes"
                        ? "Yes"
                        : "No"}
                    </ExpandedValue>
                  </ExpandedText>

                  <ExpandedText>
                    <ExpandedLabel>Microchipped</ExpandedLabel>
                    <ExpandedValue>
                      {dogProfile.microchipped === true ||
                      dogProfile.microchipped === "true" ||
                      dogProfile.microchipped === "Yes"
                        ? "Yes"
                        : "No"}
                    </ExpandedValue>
                  </ExpandedText>

                </motion.div>
              )}
            </AnimatePresence>

            <Box sx={{ marginTop: "8px" }}>
              {/* Pledges Section */}
              <Box sx={{ marginBottom: "12px" }}>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(3, Math.min((totalPledged / 500) * 100, 100))}
                  sx={{
                    height: "7px",
                    borderRadius: "2px",
                    backgroundColor: "#374151",
                    marginBottom: "6px",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: COLORS.primaryGreen,
                      borderRadius: "2px",
                    },
                  }}
                />
                <ProgressHeader>
                  <Box sx={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                    <ProgressLabel>PledgeS</ProgressLabel>
                    <Typography sx={{ fontSize: "12px", color: "#9CA3AF", fontWeight: "500" }}>
                      (one-time)
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "baseline", gap: "2px" }}>
                    <ProgressLabel sx={{ color: COLORS.primaryGreen }}>
                      ${totalPledged.toLocaleString() || "0"}
                    </ProgressLabel>
                    <ProgressLabel>/ $500</ProgressLabel>
                  </Box>
                </ProgressHeader>
              </Box>

              {/* Pledge Subscriptions Section */}
              <Box>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(3, Math.min((totalSubscriptions / 250) * 100, 100))}
                  sx={{
                    height: "7px",
                    borderRadius: "2px",
                    backgroundColor: "#374151",
                    marginBottom: "6px",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: COLORS.primaryGreen,
                      borderRadius: "2px",
                    },
                  }}
                />
                <ProgressHeader>
                  <Box sx={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                    <ProgressLabel>Pledge Subscriptions</ProgressLabel>
                    <Typography sx={{ fontSize: "12px", color: "#9CA3AF", fontWeight: "500" }}>
                      (per month)
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "baseline", gap: "2px" }}
                  >
                    <ProgressLabel sx={{ color: COLORS.primaryGreen }}>
                      ${totalSubscriptions.toLocaleString()}
                    </ProgressLabel>
                    <ProgressLabel>/ $250</ProgressLabel>
                  </Box>
                </ProgressHeader>
              </Box>
            </Box>

            <DonationAmounts sx={{ marginTop: "16px", marginBottom: "8px" }}>
              {donationAmounts.map((amount) => (
                <AmountButton
                  key={amount}
                  selected={selectedAmount === amount && customAmount === ""}
                  onClick={() => {
                    setSelectedAmount(amount);
                    setCustomAmount("");
                  }}
                >
                  ${amount}
                </AmountButton>
              ))}
              <AmountTextField
                placeholder="Custom"
                value={customAmount}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  setCustomAmount(value);
                  if (value && parseInt(value) > 0) {
                    setSelectedAmount(parseInt(value));
                  }
                }}
                onFocus={() => {
                  if (!customAmount) {
                    setCustomAmount("");
                  }
                }}
                autoComplete="off"
              />
            </DonationAmounts>

            <DonateButton
              onClick={handleDonateClick}
              disabled={isProcessingPledge || isRescued || isExpired}
              sx={{
                backgroundColor: "#10B981",
                marginTop: "8px",
                marginBottom: "8px",
                "&:hover": {
                  backgroundColor: "#059669",
                },
                "&:disabled": {
                  backgroundColor: "#374151",
                  color: "#FFFFFF",
                },
              }}
            >
              {isProcessingPledge ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                `🙏 PLEDGE`
              )}
            </DonateButton>

            <Typography
              sx={{
                fontSize: "12px",
                color: "#9CA3AF",
                fontWeight: "400",
                marginTop: "4px",
                textAlign: "left",
                textTransform: "uppercase",
              }}
            >
              ✅ Your card is ONLY charged if a rescue uploads a Proof of Rescue. You'll get notified.
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", marginTop: "8px" }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#9CA3AF",
                  fontWeight: "400",
                  textAlign: "left",
                  textTransform: "uppercase",
                }}
              >
                {dogProfile.saviorReward
                  ? `👉 85% pledges go to rescue org. 15% goes to the hero who made this listing.`
                  : "👉 100% pledges go to the rescue organization"}
              </Typography>
              {dogProfile.saviorReward && (
                <IconButton
                  onClick={() => setShowSaviorRewardInfo(true)}
                  sx={{
                    padding: "2px",
                    minWidth: "auto",
                    color: "#9CA3AF",
                    "&:hover": {
                      color: "#FFFFFF",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <InfoIcon sx={{ fontSize: "14px" }} />
                </IconButton>
              )}
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#9CA3AF",
                  fontWeight: "400",
                }}
              >
                .
              </Typography>
            </Box>
            {/* Upload Proof of Rescue Section */}
            <Box sx={{ marginTop: "24px", textAlign: "center" }}>
              <Button
                disabled={hasPendingClaim || isRescued || isExpired}
                onClick={() => {
                  if(isRescued || hasPendingClaim || isExpired) {
                    return
                  }
                  if (!user) {
                    setGlobalState({
                      ...globalState,
                      showAuthModal: true,
                    });
                  } else {
                    setGlobalState({
                      ...globalState,
                      showClaimFundsModal: true,
                      selectedDog: dogProfile,
                    });
                  }
                }}
                sx={{
                  width: "100%",
                  padding: "12px 16px",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "2px",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  backgroundColor: "#FFFFFF",
                  color: "#000000",
                  fontWeight: "bold",
                  border: "1px solid #E5E7EB",
                  borderRadius: "6px",
                  "&:hover": {
                    backgroundColor: "#F3F4F6",
                    color: "#000000",
                  },
                  "&:disabled": {
                    backgroundColor: "#F3F4F6",
                    color: "#6B7280",
                  },
                  "& .MuiButton-startIcon": {
                    margin: 0,
                    marginBottom: "4px",
                  },
                }}
              >
                <Typography sx={{ fontSize: "10px", fontWeight: "500", textTransform: "uppercase", color: (hasPendingClaim || isRescued) ? COLORS.primaryGreen : "#6B7280" }}>
                  {isRescued ? "APPROVED APPLICATION" : hasPendingClaim ? "PENDING VERIFICATION" : "Rescues Only"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <UploadIcon sx={{ fontSize: "16px" }} />
                  <Typography sx={{ fontSize: "14px", fontWeight: "bold", textTransform: "uppercase" }}>
                    Upload Proof of Rescue
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "10px", fontWeight: "500", textTransform: "uppercase", color: "#6B7280" }}>
                  1-Day Fund Transfers
                </Typography>
              </Button>
              {hasPendingClaim && !isRescued && (
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#10B981",
                    fontWeight: "500",
                    textAlign: "center",
                    marginTop: "8px",
                  }}
                >
                  APPLICATION SUBMITTED
                </Typography>
              )}
              {isRescued && (
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#10B981",
                    fontWeight: "500",
                    textAlign: "center",
                    marginTop: "8px",
                  }}
                >
                  🎉 FUNDS TRANSFERRED 🎉
                </Typography>
              )}
            </Box>

            {/* Savior Attribution Section */}
            {saviorUser && (
              <Box
                sx={{
                  marginTop: "24px",
                  padding: "16px",
                  backgroundColor: "transparent",
                  borderRadius: "8px",
                  border: `1px solid ${COLORS.lightGray3}`,
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Avatar
                  src={saviorUser.photoURL}
                  alt={saviorUser.username}
                  sx={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: COLORS.backgroundCard,
                    color: COLORS.yellow,
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  {saviorUser.username?.charAt(0).toUpperCase() || "?"}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#10B981",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      marginBottom: "2px",
                    }}
                  >
                    Posted By
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#FFFFFF",
                      fontWeight: "600",
                    }}
                  >
                    {saviorUser.username || "Anonymous Savior"}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography
                    sx={{
                      fontSize: "24px",
                      color: "#FFFFFF",
                      fontWeight: "700",
                      lineHeight: "1",
                    }}
                  >
                    {saviorUser.dogsListedCount || 0}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#9CA3AF",
                      fontWeight: "500",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Dogs Listed
                  </Typography>
                </Box>
              </Box>
            )}

          </DogInfoSection>
        </TopSection>
      </MainContainer>

      {/* Horizontal Scroller - Dogs from same shelter */}
      {dogsForScroller.length > 0 && dogProfile?.shelter?.name && (
        <HorizontalScrollerContainer>
          <ScrollerInner>
            <ShelterLabel>
              {dogProfile.shelter.name}:
            </ShelterLabel>
            <DogScrollerWrapper>
              {dogsForScroller.map((dog) => {
                const primaryMedia = dog.videos?.[0] || dog.images?.[0];
                const isUrgent = dog.timeRemainingMs < 24 * 60 * 60 * 1000; // Less than 24 hours
                const pledgeGoal = 500;
                const pledgePercentage = Math.min(((dog.pledgedAmount || 0) / pledgeGoal) * 100, 100);

                return (
                  <Link
                    to={`/${dog.slug}`}
                    key={dog.id}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                  >
                    <DogScrollerCard>
                      <DogCardThumbnail
                        src={primaryMedia}
                        alt={dog.name}
                        variant="rounded"
                      >
                        {!primaryMedia && <PetsIcon />}
                      </DogCardThumbnail>
                      <DogCardMetaRow>
                        <DogCardName>{dog.name}</DogCardName>
                        <DogCardAge>{formatDogAge(dog.age)}</DogCardAge>
                      </DogCardMetaRow>
                      <DogCardTimeRow>
                        <DogCardTimeLabel>⏰</DogCardTimeLabel>
                        <DogCardTime>
                          {dog.timeRemainingFormatted} LEFT
                        </DogCardTime>
                      </DogCardTimeRow>
                      <DogCardTimeRow>
                        <DogCardTimeLabel>Days at Shelter</DogCardTimeLabel>
                        <DogCardTime>
                          {dog.daysAtShelter || 'N/A'}
                        </DogCardTime>
                      </DogCardTimeRow>
                      <DogCardProgressBar
                        variant="determinate"
                        value={Math.max(3, pledgePercentage)}
                      />
                    </DogScrollerCard>
                  </Link>
                );
              })}
            </DogScrollerWrapper>
          </ScrollerInner>
        </HorizontalScrollerContainer>
      )}

      {/* Footer */}
      <FooterComponent />

      {/* Modals */}
      <Elements stripe={stripePromise}>
        {globalState.showSubModal && <SubModal />}
        {globalState.showAddCardModal && <AddCardModal />}
        {globalState.showConfirmPledgeModal && (
          <ConfirmPledgeModal
            selectedAmount={selectedAmount}
          />
        )}
      </Elements>
      {globalState.showAuthModal && <AuthModal />}
      {globalState.showClaimFundsModal && <ClaimFundsModal />}
      <SaviorRewardInfoModal
        open={showSaviorRewardInfo}
        onClose={() => setShowSaviorRewardInfo(false)}
      />
    </PageContainer>
  );
};

export default DogProfilePage;
